<template>
    <div class="context">
        <div class="tool">
            <el-input placeholder="请输入平台名称" v-model="searchForm.searchInfo" style="width:200px;">
               <el-button slot="append" icon="el-icon-search" @click='Search'></el-button>
           </el-input>
       </div>


       <div style="margin-top:15px;width:100%">
            <el-row v-for="(page, index) of pages" :key="index" :gutter="20" style="margin:10px">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" v-for="item of page" :key="item.uc_id">
                    <el-card style="height:255px;">
                        <div style="display: flex;flex-direction: column; justify-content:start;">
                            <div style="position: relative;">
                                <span style="position: absolute;top: 80%;color: white;width: 100%;text-align: center;font-size: 1.1rem;font-weight: 800;">{{item.uc_name}}</span>
                                <img :src='ImageUrl(item.uc_id)' style="width: 98%;max-height: 190px;border-radius:3%;position: block;">
                                
                            </div>
                            <div style="display: flex;flex-direction: row; justify-content:space-between;align-items:center;">
                                <span class="txt">上报车场数：{{item.count}}</span>
                                <el-link type="primary" @click="Detail(item.uc_id)" class="txt">详情</el-link>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
       </div>


       <el-pagination class="fy" layout="prev, pager, next" @current-change="current_change" :total="searchForm.total" background :page-size="searchForm.pageSize"></el-pagination>
    
    
       <el-dialog title="上报车场详情" :visible.sync="dialogVisible" width='90%' :append-to-body='true'>
            <el-button type="primary" class="el-icon-plus" style="margin-right:20px" @click="AddClick"> 新增</el-button>
            <el-table :data='UploadParkDataList' border stripe :highlight-current-row='true'>
                <el-table-column align="center" prop="pk_cloud_id" label="车场编号"></el-table-column>
                <el-table-column align="center" prop="pk_name" label="车场名"></el-table-column>
                <el-table-column align="center" prop="ud_state" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.ud_state === 0 ?'success':'danger'" disable-transitions>{{scope.row.ud_state===0?'正常':'已取消'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="du_last_time" label="上报时间"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <div class="link_btn">
                            <el-link type="primary" @click="Edit(scope.row)">修改</el-link>
                            <el-link v-if="scope.row.ud_state===0" type="warning" @click="Cancel(scope.row,1)">取消上报</el-link>
                            <el-link v-if="scope.row.ud_state===1" type="success" @click="Cancel(scope.row,0)">重新上报</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;margin-top: 10px;">
                <el-pagination  class="fy" layout="prev, pager, next" @current-change="ChangePage" :total="DetailForm.total" background :page-size="DetailForm.pageSize"></el-pagination>
            </div>
       </el-dialog>

    
       <el-dialog title="上报车场" :visible.sync="paramDialogVisible" width='800px' :append-to-body='true'>
           <div class="tool" style="align-items: center;margin-left: 27px;">
               <label style="width: 80px;">停车场：</label>
               <el-select v-model="paramForm.ud_park_id" style="width:100%;">
                    <el-option label=" " :value="0"></el-option>
                    <el-option v-for="item in ParkList" :key="item.pk_id" :label="item.pk_name" :value="item.pk_id"></el-option>
                </el-select>
           </div>
            <component :is="componentName" :paramForm="paramForm" style="margin-top: 10px;" ref="paramComponent"></component>
            <span slot="footer" class="dialog-footer">
                <el-button @click="paramDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
       </el-dialog>
    </div>
</template>

<script>
import util from '../../util/util'

export default{
    data: function (){
        return{
            apiArr:[
                {
                    id:1,
                    name:'hntyx',//海南天涯行
                    imgUrl:require('../../assets/image/img/1.png')
                }

            ],
            searchForm:{
                searchInfo:'',
                pageNo:1,
                pageSize:16,
                total:0
            },
            DataList:[],



            DetailForm:{
                id:0,
                pageNo:1,
                pageSize:15,
                total:0
            },
            UploadParkDataList:[],//车场详情
            ParkList:[],//所有车场


            dialogVisible:false,


            componentName:'',

            paramDialogVisible:false,
            paramForm:{
                ud_id:0,
                ud_park_id:0,
                ud_parameter1:'',
                ud_parameter2:'',
                ud_parameter3:'',
                ud_parameter4:'',
                ud_parameter5:'',
                ud_parameter6:'',
                ud_parameter7:'',
                ud_parameter8:'',
                ud_parameter9:'',
                ud_state:0
            },

            rules:{}
        }
    },
    components: {

    },
    computed: {
        pages () {
            const pages = []
            this.DataList.forEach((item, index) => {
                const page = Math.floor(index / 4)// 4条为一行
                if (!pages[page]) {
                pages[page] = []
                }
                pages[page].push(item)
            })
            return pages
        },
        ImageUrl(){
            return function (id) {
                let url=''
                let arr= this.apiArr.filter(a=>a.id===id)
                if(arr.length>0){
                    url=arr[0].imgUrl
                }
                return url
            }
           
        }
    },
    created () {
        this.getDataList()
    },
    methods:{
        getDataList(){
            util.Get('uploaddata/getuploaddatalist', this.searchForm).then(res => {
                if (res.rpStatus === 10000) {
                    this.DataList = res.list
                    this.searchForm.total = res.total
                }
            })
        },
        current_change(page){
            this.searchForm.pageNo = page
            this.GetDataList()
        },
        Search(){
            this.getDataList()
        },



        Detail(ap_id){
            this.dialogVisible=true
            this.title='上报车场详情'

            this.DetailForm.id=ap_id
            this.DetailForm.pageNo=1
            this.GetDetailPark()

            this.loadComponent()
        },
        GetDetailPark(){
            util.Get("uploaddata/GetParkDetail",this.DetailForm).then(res=>{
                if(res.rpStatus===10000){
                    this.UploadParkDataList=res.list
                }
            })
           
            
        },
        ChangePage(page){
            this.DetailForm.pageNo=page
            this.GetDetailPark()
        },
        loadComponent(){
            var name=''
            let arr= this.apiArr.filter(a=>a.id===this.DetailForm.id)
            if(arr.length>0){
                name=arr[0].name
            }
            import('../../components/api/'+name+'.vue').then(component=>{
                this.componentName=component.default
            })
        },



        AddClick(){
            if(this.ParkList.length===0){
                util.Get("parkmanage/getparkdatalist",{pageNo:0}).then(res=>{
                    if(res.rpStatus===10000){
                        this.ParkList=res.list
                    }
                    
                })
            }


            this.paramForm.du_park_id=0
            this.paramDialogVisible=true
            this.paramForm.ud_parameter1=''
            this.paramForm.ud_parameter2=''
            this.paramForm.ud_parameter3=''
            this.paramForm.ud_parameter4=''
            this.paramForm.ud_parameter5=''
            this.paramForm.ud_parameter6=''
            this.paramForm.ud_parameter7=''
            this.paramForm.ud_parameter8=''
            this.paramForm.ud_parameter9=''
        },
        Edit(row){
            if(this.ParkList.length===0){
                util.Get("parkmanage/getparkdatalist",{pageNo:0}).then(res=>{
                    if(res.rpStatus===10000){
                        this.ParkList=res.list
                        this.paramForm.ud_park_id=row.ud_park_id
                    }
                })
            }
            this.paramForm.ud_id=row.ud_id
            this.paramDialogVisible=true
            this.paramForm.ud_parameter1=row.ud_parameter1
            this.paramForm.ud_parameter2=row.ud_parameter2
            this.paramForm.ud_parameter3=row.ud_parameter3
            this.paramForm.ud_parameter4=row.ud_parameter4
            this.paramForm.ud_parameter5=row.ud_parameter5
            this.paramForm.ud_parameter6=row.ud_parameter6
            this.paramForm.ud_parameter7=row.ud_parameter7
            this.paramForm.ud_parameter8=row.ud_parameter8
            this.paramForm.ud_parameter9=row.ud_parameter9
            this.dialogVisible=true
            this.title='上报车场详情'
            this.loadComponent()
        },
        Cancel(row,state){
            let msg='确定'+(state===0?'设置':'取消')+'车场“' + row.pk_name + '”上报？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.paramForm.ud_id=row.ud_id
                    this.paramForm.ud_state=state
                    util.Post('uploaddata/uploadstate',this.paramForm).then(res=>{
                    if(res.rpStatus===10000){
                        this.$message.success((state===0?'设置':'取消')+'车场上报成功')
                        this.paramDialogVisible=false
                        this.GetDetailPark()
                    }
                    else{
                        this.$message.error((state===0?'设置':'取消')+"车场上报失败")
                    }
                })
            }).catch(e => e)
        },
        submit(){
            if(this.paramForm.ud_park_id===0){
                this.$message.error('请选择上报车场')
                return
            }
            const flag = this.$refs.paramComponent.validateForm()
            if (flag) {
                this.paramForm.ud_api_id=this.DetailForm.id
                util.Post('uploaddata/uploadParam',this.paramForm).then(res=>{
                    if(res.rpStatus===10000){
                        this.$message.success('设置车场上报成功')
                        this.paramDialogVisible=false
                        this.GetDetailPark()
                    }
                    else{
                        this.$message.error("设置车场上报失败:"+res.rpMsg)
                    }
                })
            }
        }
    }
}
</script>


<style scoped>
.context{
    display: flex;
    flex-direction: column;
    justify-content: start;
    height: 100%;
}
.tool{
    display: flex;
    flex-direction: row;
    justify-content: start;
}
.el-table{
    margin-top:10px;
}
.el-link{
    margin-right: 10px;
    font-size: 12px;
}
.txt{
    margin-top: 5px;
    font-weight: 600;
    font-family:Arial, Helvetica, sans-serif;
    font-size: 0.9rem;
}




::v-deep .el-dialog{
  --el-bg-color:#000741 !important;
}
::v-deep .el-dialog__header{
  --el-text-color-primary:#1effff;
  --el-text-color-regular:#fff;
  padding: 0px !important;
  background-color: #309CE2;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__title{
    color: white;
}

::v-deep .el-dialog__headerbtn .el-dialog__close{
    color: white;
} 
</style>